import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Spin, Empty } from 'antd';
import DummyCayegory from '../../Assets/Images/dummy_category.png'
import API from '../../ApiService/ApiService';
import { categoryStart, categorySuccess, categoryFailure } from '../../Store/Slice/CategorySlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import pro_video from '../../Assets/Images/video/product.mp4'
import { WEB_URL } from '../../config';
import bg from '../../Assets/Images/bg.png'
import { Helmet } from 'react-helmet';
const Category = () => {
  const [loading, setLoading] = useState(false);
  const api = new API();
  const dispatch = useDispatch();
  const [finalFilteredData, setFinalFilteredData] = useState([]);
  //redux
  const category_list = useSelector((state) => state?.category?.categorylist?.data);
  //init
  useEffect(() => {
    categoryList();
  }, []);
  //category list
  const categoryList = async () => {
    setLoading(true);
    await api.getAll(dispatch, [categoryStart, categorySuccess, categoryFailure, "categorylist"], 'category/filter', { status: true }, (err, res) => {
      
      if (err) {
        dispatch(categoryFailure());
        dispatch(categorySuccess({ type: "categorylist", data: [] }));
      } else {
        setFinalFilteredData(res?.data?.data);
      }
      setLoading(false);
    })
  };

  const handleFilter = (e) => {
    const keys = ["name"];
    const filteredData = category_list?.filter((item) => {
      return keys.some((key) => {
        return item[key].toLowerCase().includes(e.toLowerCase())
      })
    });
    setFinalFilteredData(filteredData);
  }

  if(loading){
    return <div className='wrapper_spin'><Spin/></div>
  }



  return (
    <CategorySection>
    <Helmet> <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org/", 
      "@type": "BreadcrumbList", 
      "itemListElement": [{
        "@type": "ListItem", 
        "position": 1, 
        "name": "Home",
        "item": "https://www.reachemchemicals.com/"  
      },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Our Category",
        "item": "https://www.reachemchemicals.com/our-product"  
      }]
    })}
    </script>
  </Helmet>
       <div className="banner_section">
      <video className="slide-video slide-media" autoPlay loop muted playsInline preload="auto" poster="image/product.webp">
        <source src={pro_video} type="video/mp4" />
      </video>
    </div>
    <div className='head_text'>
      <div className='wrapper'>
      <div className='head_text_align'>
      <h1>Our Products</h1>
      <p>We manufacture the following tailor-made products to meet the requirements of our customers.</p>
      <a href={`${WEB_URL}our-product/products/`} title="View Our Products" class="pro-btn ">
			<button>View Our Products</button>
      </a>
      </div>
      </div>

    </div>
      {loading ? (
        <div className='wrapper'>
          <div className='loader'>
            <Spin size="large" />
          </div>
        </div>
      ) : (
        <section className="category_section_dynamic">
          <div className="wappear">
            <div className="category_section_dynamic_align">
              <div className="dynamic_category_top">
                <div className="dynamic_category_top_left">
                  <ul>
                    <li>Home</li>
                    <li>Category</li>
                  </ul>
                </div>
                <div className="dynamic_category_top_right">
                  <div className="dynamic_search_btn">
                    <input type="text" placeholder="Search Product Name, Number, CAS Number" onChange={(e) => handleFilter(e.target.value)} />
                  </div>
                  {/* <div className="dynamic_cart_btn">
                  <div className="badge_cart">
                    <img src={CartImg} alt="cart" />
                    <span>1</span>
                  </div> Cart
                </div> */}
                </div>
              </div>
              {
                finalFilteredData?.length > 0 ? (
                  <div className="dynamic_category_list">
                    {
                      category_list?.length > 0 ? (
                        finalFilteredData?.map((item, index) => {
                          return (
                            <Link to={`${WEB_URL}our-product/category/${item?.slug}`} key={index}>
                              <div className="dynamic_category_item" key={index}>
                                <div className="dynamic_category_item_img">
                                  <img src={item?.image[0]?.image_path ? api.apiUrl + item?.image[0]?.image_path : DummyCayegory} alt="category" />
                                </div>
                                <div className="dynamic_category_item_text">
                                  <h4>{item?.name}</h4>
                                </div>
                              </div>
                            </Link>
                          )
                        })
                      ) : (
                        <Spin size="large" />
                      )
                    }
                  </div>
                ) : (
                  <div className='no_data_found'>
                    <Empty />
                  </div>
                )
              }


            </div>
          </div>
        </section>
      )}
    <div className="our_product_bottom_cnt">
	<div className="wappear">
		<h2 >We can commercialize your catalogue product needs to be more competitive in this global market.</h2>
		<a href={`${WEB_URL}contact-us.php`} title="Enquire Now"><button>Enquire Now</button></a>
	</div>
</div>
    </CategorySection>
  )
}

export default Category;


const CategorySection = styled.section`
  font-family: var(--regular);
  position: relative;
  margin: 0 0 0px 0;

a {
  text-decoration: none !important;
}
.banner_section {
  width: 100%;
  display: inline-block;
  position: relative;
}
.banner_section video {
  width: 100%;
    /* height: 500px; */
    display: inline-block;
    object-fit: cover;
}

.category_section_dynamic {
  margin: 50px 0 0 0;
}

.head_text_align {
  margin: 60px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
}
.head_text_align h1 {
  font-size: 38px;
}
.head_text_align p {
  max-width: 50%;
  line-height: 1.5;
  margin: auto;
}
.pro-btn button {
    padding: 10px 25px;
    font-size: 16px;
    background: #d55560;
    color: #fff;
    font-weight: 400;
    border: none;
    border-radius: 10px;
    cursor: pointer;
}
.pro-btn {
    position: absolute;
    top:0;
    right:0;
}
.our_product_bottom_cnt {
display: inline-block;
    width: 100%;
    padding: 100px 0;
    margin: 50px 0 0px 0;
    background: url(${bg});
    background-size: cover,contain;
    background-position: center,right bottom;
    background-repeat: no-repeat,no-repeat;
    text-align: center;
}
.our_product_bottom_cnt h2 {
    font-family: Helvetica;
    font-size: 40px;
    color: #c84142;
    margin: 0 0 30px 0;
    text-align: center;
    line-height: 1.4;
    padding: 0 0;
    position: relative;
    -moz-text-align-last: center;
    text-align-last: center;
    z-index: 20;
    font-weight: 600;
}
.our_product_bottom_cnt button {
    padding: 10px 10px;
    width: 220px;
    color: #fff;
    background: #d05858;
    font-family: Helvetica;
    font-size: 20px;
    outline: 0;
    border: 0;
    margin: auto;
    letter-spacing: 1px;
    border-radius: 5px;
}



@media screen and (max-width: 1200px) {
  .head_text_align p {
    max-width: 100%;
  }
  .pro-btn { 
    position: relative;
  }
  .our_product_bottom_cnt {
    margin: 40px 0 0 0;
    padding: 60px 0;
  }
}

@media screen and (max-width: 768px) {
  .our_product_bottom_cnt h2 {
    font-size: 20px;
  }
  .our_product_bottom_cnt button {
    width: auto;
    font-size: 16px;
  }

}

`;